import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Container, ButtonSendAgain } from "./styles";
import { makeRegisterOTP, makePutOTP } from "../../../api/customer";
import LoaderSpinner from "../../../components/LoaderSpinner";
import ReactCodeInput from "react-code-input";
import { FiRotateCcw } from "react-icons/fi";
import LogoImg from "../../../assets/posherlogo.png";
import { LoginFooter } from "../../Login/components/LoginFooter";

const RegisterOTP = ({ location }) => {
  const navigation = useHistory();
  const deep = location?.state?.callback;
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");

  const doRegisterOtp = async () => {
    try {
      setLoading(true);

      await makeRegisterOTP(code);

      toast.success("Código registrado");

      if (deep) {
        return navigation.push(deep);
      }

      return navigation.push("Home");
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const doResendOtp = async () => {
    try {
      setLoading(true);

      await makePutOTP();

      toast.success("Código reenviado");

      setTimer(30);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (timer === 0) return;
      setTimer((prev) => (prev -= 1));
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [timer]);

  useEffect(() => {
    if (code.length === 6) {
      let isMounted = true;

      if (isMounted) {
        doRegisterOtp();
      }

      return () => {
        isMounted = false;
      };
    }
  }, [code]);

  return (
    <Container>
      <LoaderSpinner loading={loading} />
      <img src={LogoImg} alt="POSHER" className="logo-img-login" />

      <div className="code-forms">
        <span className="login-text">
          Preencha com o código enviado por e-mail e SMS
        </span>

        <ReactCodeInput
          className="input-code"
          type="number"
          fields={6}
          onChange={(cod) => setCode(cod)}
        />

        <ButtonSendAgain onClick={doResendOtp} disabled={timer !== 0}>
          {timer !== 0 ? (
            <span className="text-button-code">
              Você pode reenviar o código em {timer} segundos
            </span>
          ) : (
            <div>
              <FiRotateCcw size={20} color="#FFF" />
              <span className="text-button-code">enviar novamente</span>
            </div>
          )}
        </ButtonSendAgain>
      </div>

      <LoginFooter />
    </Container>
  );
};

export default RegisterOTP;
